import { render, staticRenderFns } from "./StatusCountTable.vue?vue&type=template&id=9dc5d9a2&scoped=true&"
import script from "./StatusCountTable.vue?vue&type=script&lang=js&"
export * from "./StatusCountTable.vue?vue&type=script&lang=js&"
import style0 from "./StatusCountTable.vue?vue&type=style&index=0&id=9dc5d9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc5d9a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
